import styled from "styled-components";
import { InputText } from "discover.medical.react-component-library";

export const SearchField = styled(InputText)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 21.25rem;
    margin-right: ${({ theme }) => theme.space.xl};
  }
`;
